import { ReactNode } from 'react'

import { Anchor } from '@percent/lemonade'

import { useOrganisationProfileContext } from '../../context/OrganisationProfileContext'

type ProfileLinkProps = {
  href: string
  children: ReactNode
  // Defaults to body-small; table cells pass 'inherit' to keep the row's size.
  fz?: string
}

export function ProfileLink({
  href,
  children,
  fz = 'var(--font-sizes-body-small)',
}: Readonly<ProfileLinkProps>) {
  const { renderLink } = useOrganisationProfileContext()

  // Mantine's Anchor defaults to its own blue and 16px; use Lemonade's tokens.
  return (
    <Anchor
      href={href}
      c="var(--semantic-interactive-default)"
      fz={fz}
      renderRoot={renderLink}
    >
      {children}
    </Anchor>
  )
}
